import React, { useEffect, useState } from 'react'

import * as S from './styles'
import { LogoNhWhite } from '@/assets/logos'
import { LanguageSwitch, ButtonIcon } from '@/components'
import { useScreen } from '@/store/screen'

export type LpHeaderProps = {
  /**
   * Background color of the header
   *
   * @default '#0708131a'
   *
   * @example
   * ```tsx
   * <Header backgroundColor="#0708131a" />
   * ```
   *
   */
  backgroundColor?: string

  /**
   * Backdrop filter of the header
   *
   * @default 'blur(10px)'
   *
   * @example
   * ```tsx
   * <Header backdropFilter="blur(10px)" />
   * ```
   *
   */
  backdropFilter?: string

  /**
   * Backdrop filter of the header
   *
   * @default 'blur(10px)'
   *
   * @example
   * ```tsx
   * <Header backdropFilter="blur(10px)" />
   * ```
   *
   */
  redirectUrl: string

  /**
   * Has translation
   *
   * @default true
   *
   * @example
   * ```
   * <Header hasTranslation=false />
   * ```
   *
   */
  hasTranslation?: boolean
}

export type SubOptions = {
  index: number
  show: boolean
}
export const LpHeader: React.FC<LpHeaderProps> = ({
  backgroundColor,
  backdropFilter,
  redirectUrl,
  hasTranslation = true,
}) => {
  const [shrinked, setShrink] = useState(false)

  const { isBiggerMobile } = useScreen()

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= window.innerHeight / 2) {
        setShrink(true)
      } else {
        setShrink(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <S.FlexContainerHeader
      backgroundColor={backgroundColor}
      backdropFilter={backdropFilter}
      padding="0"
      id="lp-header-container"
    >
      <S.HeaderContainer
        shrinked={shrinked}
        id="header-container"
        hasTranslation={hasTranslation}
      >
        <div className="images">
          <ButtonIcon
            icon={LogoNhWhite}
            alt="Logo branca da nata.house"
            onClick={() => window.open(redirectUrl, '_self')}
          />
        </div>
        {hasTranslation && (
          <LanguageSwitch
            isBiggerMobile={isBiggerMobile}
            darkMode
            className="language-switch"
          />
        )}
      </S.HeaderContainer>
    </S.FlexContainerHeader>
  )
}
